module.exports = __webpack_public_path__ + "static/media/bookmark.c051083a.svg";